
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="workflowTargetInfo.correctRole" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>This step is currently unavailable.</p>
      </div>
    </div>
  </div>
</div>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row step-description-block">
    <div class="float-left">
      <div class="col" *ngIf="!stepIsComplete">
        <p>Please mark all assets that have been sent to SAP.</p>
      </div>
      <div class="alert alert-info" *ngIf="stepIsComplete"><span>All assets have been marked as moved to SAP. Please proceed to the next step</span></div>
    </div>
    <div class="float-right">
      <div class="col">
        <button class="btn btn-outline-danger" type="button" (click)="rejectDeployment()"><span class="oi oi-warning"></span> Reject Deployment</button>
      </div>
    </div>
  </div>
  <div class="row alert-container-block">
    <error [error]="error"></error>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filterAssets.length" (onChange)="onListControlsChange($event)">
        <div class="dropdown" [hidden]="disableAll">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" [downloadFile]="'/api/DeploymentWorkflow/export-deployed-devices-report'" [params]="{deploymentId: workflowTargetInfo.targetId}"><span class="oi oi-cloud-download"></span> Create Deployed Asset Report</a><a class="dropdown-item" href="javascript:void(0);" (click)="deselectAll()">Deselect all</a><a class="dropdown-item" href="javascript:void(0);" (click)="selectAll()">Select all</a></div>
        </div>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>In SAP</th>
            <th>SKU</th>
            <th>Model</th>
            <th>Device Key</th>
            <th>Serial Number</th>
            <th>Asset Tag</th>
            <th>Building</th>
            <th>Floor</th>
            <th>Map ID</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let asset of displayAssets; let idx = index;">
            <td>
              <div class="form-check" *ngIf="!asset.disabled">
                <input class="form-check-input" type="checkbox" name="asset-selection-checkbox-{{asset.id}}" [(ngModel)]="asset.sentToSAP" [hidden]="disableAll || asset.disabled" [disabled]="disableAll || asset.disabled" (change)="updateSelection(asset)">
              </div>
              <p class="text-center font-italic" *ngIf="asset.disabled">{{ asset.statusKey === 'exists-in-k2' || asset.statusKey === 'found-in-k2' ? 'Disabled' : 'Disabled: Upload to K2 first' }}</p>
            </td>
            <td>{{ asset.productNumber }}</td>
            <td><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>{{ asset.model }}</span></td>
            <td *ngIf="asset.deviceKey">{{ asset.deviceKey }}</td>
            <td class="text-red" *ngIf="!asset.deviceKey">REMOVAL</td>
            <td>{{ asset.serialNumber }}</td>
            <td>{{ asset.assetTag }}</td>
            <td>{{ asset.building }}</td>
            <td>{{ asset.floor }}</td>
            <td>{{ asset.floorMapId }}</td>
          </tr>
          <tr *ngIf="displayAssets.length === 0">
            <td colspan="8">
              <p class="text-center empty-table-message">There are no assets to display</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>